export default __webpack_public_path__ + "static/media/webdev.572427fc.jpeg";